<!--
 * @Description: 月采购金额统计 - 折线图
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <div class="line-chart">
    <div class="title">
      <img src="@/img/datav-tc/title_icon.png" alt="" />
      <span>月采购金额统计</span>
    </div>
    <div id="AmountLineChart" style="width:100%;height:calc(100% - 60px)"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getAmountLineChart, getGroupStoreList } from '@/api/dashboard-tc'
let myChart

export default {
  data() {
    return {
      appid: '',
      data: {
        months: [],
        values: [],
      },
      timer: null,
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('AmountLineChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initAppid()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initAppid() {
      try {
        const res = await getGroupStoreList()
        if (res.code === 0 && res.data) {
          const lifengItem = res.data.find(
            item => item.storeName && item.storeName.includes('俪丰'),
          )
          if (lifengItem) {
            this.appid = lifengItem.appid
            this.fetchData()
            this.timer = setInterval(() => {
              this.fetchData()
            }, process.env.VUE_APP_LTIME_TC)
          }
        }
      } catch (error) {
        console.error('获取集团列表失败:', error)
      }
    },
    async fetchData() {
      try {
        if (!this.appid) {
          console.warn('appid未获取到')
          return
        }
        const res = await getAmountLineChart(this.appid)
        if (res.code === 0) {
          this.data.months = res.data.xaxis || res.data.xAxis
          this.data.values = res.data.series
          this.initChart()
        }
      } catch (error) {
        console.error('获取金额统计失败:', error)
      }
    },
    initChart() {
      const option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#FEDB65',
          borderWidth: 1,
          confine: true,
          padding: [8, 12],
          extraCssText: 'box-shadow: 0 0 10px rgba(254, 219, 101, 0.3);',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#FEDB65',
              width: 1,
              type: 'dashed',
            },
          },
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          formatter: params => {
            if (!params || params.length === 0) return ''
            const data = params[0]
            return `
              <div style="padding: 8px;">
                <div style="font-size: 14px; color: #899dbf; margin-bottom: 4px;">${data.name}</div>
                <div style="font-size: 16px; font-weight: bold; color: #FEDB65;">采购金额: ${data.value}万元</div>
              </div>
            `
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.months,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 14,
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
              type: 'dashed',
            },
          },
          axisLabel: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
        series: [
          {
            name: '采购金额',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 4,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FEDB65' },
                { offset: 1, color: '#FFA600' },
              ]),
              shadowBlur: 15,
              shadowColor: '#FFA600',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(254, 219, 101, 0.4)' },
                { offset: 0.5, color: 'rgba(255, 166, 0, 0.2)' },
                { offset: 1, color: 'rgba(255, 166, 0, 0.05)' },
              ]),
            },
            itemStyle: {
              color: '#FEDB65',
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 10,
              shadowColor: '#FFA600',
            },
            emphasis: {
              scale: true,
              itemStyle: {
                shadowBlur: 20,
                shadowColor: '#FFA600',
              },
            },
            data: this.data.values,
            animationDuration: 2000,
            animationEasing: 'cubicOut',
          },
        ],
      }
      myChart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.line-chart {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;

  .title {
    position: relative;
    font-size: 24px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 0px;

    img {
      margin-right: 3px;
    }
  }
}
</style>
